module.exports = __webpack_public_path__ + "static/media/correcto.20a9c3b3.png";